import BaseApi from './BaseApi';
import { ShipmentTrackingRequest } from './request_type/ShipmentTrackingRequest';
import { GetEtaForTrackingRequest } from './request_type/GetEtaForTrackingRequest';
import { DownloadPodRequest } from './request_type/DownloadPodRequest';
import { common } from '../config/configuration';
import { ThemeCssRequest } from './request_type/ThemeCssRequest';
import { ShipmentTokenRequest } from './request_type/ShipmentTokenRequest';

export default class ShipmentTrackingApi extends BaseApi {
    constructor() {
        super();
        this.BASE_URL = common.apiUrl;
    }
    public async ShipmentTrackingAction(
        payload: ShipmentTrackingRequest,
    ): Promise<any> {
        let data: any = await this.postOpenApi('getShipmentTracking', payload);
     //console.log(data);
        return data;

    }
    public async GetEtaForTracking(payload: GetEtaForTrackingRequest): Promise<any> {
        let data: any = await this.postOpenApi('getEtaInfoTracking', payload);
        return data;
      }

      public async DownloadPodAction(payload: DownloadPodRequest): Promise<any> {
        let data: any = await this.postOpenApi('searchDeliveryAddress', payload);
        return data;
      }
      public async GetThemeCss(payload: ThemeCssRequest): Promise<any> {
        let data: any = await this.postOpenApi('../v1/getclientcss', payload);
        return data;
      }
        public async ShipmentTokenAction(payload: ShipmentTokenRequest): Promise<any> {
        let data: any = await this.postOpenApi('getShipmentToken', payload);
        return data;
      }
      // BR-1929: Fragilistics' POD from PODFather, for a job number our system does not know. The API gates it
      // (PodFatherGuard: number format, per-IP rate, Fragilistics origin) and answers {status:"true", pod_path}.
      public async EPodFather(jobid: string): Promise<any> {
        let data: any = await this.postOpenApi('ePodFather', { jobid });
        return data;
      }
}
